import { FallbackStorage } from 'utilities/FallbackStorage';
import { JsonSafe } from 'utils/JsonSafe';

/**
 * Возвращает доступное хранилище.
 * @returns {Storage|FallbackStorage}
 */
function getAvailableStorage() {
    try {
        // Может быть выключено в IE, переполнено
        // или недоступно в приватных вкладках.
        localStorage.setItem('reflectStorage', '1');
        localStorage.removeItem('reflectStorage');

        return localStorage;
    } catch (reason) {}

    return new FallbackStorage();
}

/**
 * Позволяет работать с localStorage без необходимости
 * контролировать исключения и восстанавливать типы данных.
 */
class ReflectStorage {
    _storage: FallbackStorage | Storage;
    constructor() {
        /** @type {Storage|FallbackStorage} */
        this._storage = getAvailableStorage();
    }

    /**
     * Возвращает значение из localStorage,
     * соответствующее указанному ключу.
     * @param {string} key
     * @returns {string|null}
     */
    getItem(key: string) {
        try {
            return this._storage.getItem(key);
        } catch (reason) {}

        return null;
    }

    /**
     * Записывает значение в localStorage.
     * @param {string} key
     * @param {mixed} value
     */
    setItem(key: string, value: string) {
        try {
            this._storage.setItem(key, value);
        } catch (reason) {}
    }

    /**
     * Удаляет значение из localStorage.
     * @param {string} key
     */
    removeItem(key: string) {
        try {
            this._storage.removeItem(key);
        } catch (reason) {}
    }

    /**
     * Возвращает значение из localStorage,
     * соответствующее указанному ключу.
     * @param {string} key
     * @returns {mixed}
     */
    get<T = Record<string, any>>(key: string) {
        try {
            return JsonSafe.parse<T>(this._storage.getItem(key));
        } catch (reason) {}
    }

    /**
     * Записывает значение в localStorage.
     * @param {string} key
     * @param {mixed} value
     */
    set(key: string, value: any) {
        try {
            this._storage.setItem(key, JSON.stringify(value));
        } catch (reason) {}
    }

    /**
     * Удаляет значение из localStorage.
     * @param {string} key
     */
    remove(key: string) {
        this.removeItem(key);
    }
}

export const reflectStorage = new ReflectStorage();
